<template>
  <div class="pg-rule">
    <div class="close" @click="close"></div>
    <p class="text">
        活动时间：2019/09/12-2019/09/19 23:59
        <br>领奖时间：2019/09/15-2019/09/19 23:59
    </p>
  </div>
</template>
<script>

export default {
    props: ['msg'],
    mounted() {
      // console.log(this.msg);
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .pg-rule
    width: 7.5rem;
    height: 10.01rem;
    background-image url('./images/rule.png')
    background-size 100% 100%
    position absolute
    top 50%
    margin-top -5.005rem
    .text
      position: absolute;
      height: auto;
      font-size: 0.26rem;
      color: #ad0b0b;
      left: 1.21rem;
      top: 1.41rem;
      line-height: 1.5;

    .close
      position absolute
      width 0.73rem;
      height 0.73rem;
      background-image url('../images/close.png')
      background-size 100% 100%
      top -0.44rem;
      right 0.21rem;
</style>
